import type { PrincipalCalendarEventStatus } from 'models';
import { useCallback } from 'react';
import type { EventCalendarStatus } from 'ui';

export const useMapPrincipalCalendarEventStatus = () =>
  useCallback((status: PrincipalCalendarEventStatus): EventCalendarStatus => {
    switch (status) {
      case 'CANCELLED':
        return 'canceled';
      case 'CONFIRMED':
        return 'active';
    }
  }, []);
